<template>
  <div class="main">
    <!--   2022年4月21日屏蔽交互    -->
    <!--    <div class="item" id="contactQQ">-->
    <!--      <div class="contantPhone" @click="onlinePhone">-->
    <!--        <img class="icon" src="../assets/img/contact/kf.png" alt="" />-->
    <!--        在线咨询-->
    <!--      </div>-->
    <!--      <div class="contant" @click="online">-->
    <!--        <img class="icon" src="../assets/img/contact/kf.png" alt="" />-->
    <!--        在线咨询-->
    <!--      </div>-->
    <!--      &lt;!&ndash; <img class="icon" src="../assets/img/contact/kf.png" alt="" />-->
    <!--      在线咨询 &ndash;&gt;-->
    <!--    </div>-->

    <div class="item">
      <a href="tel://028-85094050" class="contantPhone">
        <img class="icon" src="../assets/img/contact/phone.png" alt="" />
        电话咨询
      </a>
      <div class="contant">
        <img class="icon" src="../assets/img/contact/phone.png" alt="" />
        电话咨询
      </div>
      <div class="item-hover">
        <div class="main-bg">
          <div>咨询电话</div>
          <div class="blod">028-85094050</div>
        </div>
      </div>
    </div>

    <div class="item">
      <el-popover
        placement="left"
        title="微信二维码"
        width="200"
        trigger="click"
      >
        <img class="phone-img" src="../assets/img/contact/erweima.png" alt="" />
        <div slot="reference" class="contantPhone">
          <img class="icon" src="../assets/img/contact/wx.png" alt="" />
          关注微信
        </div>
      </el-popover>

      <div class="contant">
        <img class="icon" src="../assets/img/contact/wx.png" alt="" />
        关注微信
      </div>

      <div class="item-hover">
        <div class="main-bg">
          <div>微信二维码</div>
          <img src="../assets/img/contact/erweima.png" alt="" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Contact",
  data() {
    // BizQQWPA.addCustom({
    //   aty: "0", //指定工号类型,0-自动分流，1-指定工号，2-指定分组
    //   nameAccount: "1261545300", //指定的聊天 QQ 号码
    //   selector: "contactQQ", //触发聊天的标签id
    // });
    return {
      QQ: "3574897917",
      phoneShow: false,
    };
  },
  methods: {
    // 在线咨询
    online() {
      window.open(
        `http://wpa.qq.com/msgrd?v=3&uin=${this.QQ}&site=qq&menu=yes`
      );
    },
    // 在线咨询手机版
    onlinePhone() {
      window.open(
        `mqqwpa://im/chat?chat_type=wpa&uin=${this.QQ}&version=1&src_type=web&web_src=http:://wpa.b.qq.com`
      );
    },
    // 关注微信
    focusWeChat() {
      this.phoneShow = true;
      // window.open("weixin://");
    },
  },
};
</script>

<style lang="less" scoped>
.main {
  position: fixed;
  right: 20px;
  bottom: 20%;
  width: 84px;
  background: #ffffff;
  border: 1px solid #e1e6f0;
  box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.1);
  border-radius: 12px;
  z-index: 8;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: 15px;
  font-weight: 400;
  color: #555555;
  .item {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 17px 0;
    cursor: pointer;
    border-top: 1px solid #e5e5e5;
    position: relative;
    .contant {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
    }
    .contantPhone {
      display: none;
    }
    .icon {
      width: 30px;
      height: 30px;
      margin-bottom: 7px;
    }
    .item-hover {
      display: none;
      position: absolute;
      right: 60px;
      font-size: 15px;
      font-weight: bold;
      color: #555555;
      text-align: center;
      .main-bg {
        background: #ffffff;
        border: 1px solid #e1e6f0;
        box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.1);
        border-radius: 12px;
        padding-top: 16px;
        padding-bottom: 10px;
        padding-left: 20px;
        padding-right: 20px;
        box-sizing: border-box;
        margin-right: 24px;
        .blod {
          font-size: 22px;
          font-weight: bold;
          color: #17212c;
          white-space: nowrap;
          margin: 0 10px;
        }
        img {
          width: 140px;
        }
      }
    }
  }
  .item:hover {
    color: #4f75c5;
    .item-hover {
      display: inline-block;
    }
  }
  .item:first-child {
    border: 0;
  }
}

@media all and (max-width: 768px) {
  .main {
    transform: scale(0.7);
    right: 0;
    bottom: 10%;
    .item {
      .contant {
        display: none;
      }
      .contantPhone {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
      }
    }
    .item:hover {
      .item-hover {
        display: none;
      }
    }
  }
  .phone-img {
    width: 100%;
  }
}
</style>
<style>
.el-popover__title {
  text-align: center !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Contact.vue